import { html } from "lit";

interface TeaserPressProps {
    date: string;
    title: string;
    linkUrl: string;
    textLimit?: boolean;
}

export const dummyPressItem: TeaserPressProps = {
    date: "12.07.2012",
    title:
        "TRUMPF Venture invertiert in Recycling-Start-up Batttery Resources lorem ipsum dolor",
    linkUrl: "#",
};

const dummyPressItems: TeaserPressProps[] = [
    {
        ...dummyPressItem,
    },
    {
        ...dummyPressItem,
        title:
            "TRUMPF beschleunigt die Ersatzteilbestellung dank Künstlicher Intelligenz",
    },
    {
        ...dummyPressItem,
        title:
            "Auf der virtuellen INTECH präsentierte TRUMPF eine neue Funktion",
    },
    {
        ...dummyPressItem,
        title: "TRUMPF befüllt es kontinuierlich mit Fotos der Bestellartikel",
    },
    {
        ...dummyPressItem,
        title: "Neue Kantenfräse für Fasen bis sieben Millimeter",
    },
    {
        ...dummyPressItem,
        title:
            "TRUMPF das TruTool TKA 700 zusätzlich mit einem Überlastschutz ausgestattet",
    },
];

export const TeaserPressTemplate = ({
    date = "12.07.2012",
    title = "So will TRUMPF die Liferzeiten für Ersatzteile halbieren",
    linkUrl = "#",
    textLimit,
}: TeaserPressProps) => {
    let titleHtml = html`
        <p class="ux-iws-teaser-press__title ux-u-text-dark">
            ${title}
        </p>
    `;
    if (textLimit) {
        titleHtml = html` <ux-text-lines-limit
            text-lines-l="2"
            text-lines-xl="2"
            >${titleHtml}
        </ux-text-lines-limit>`;
    }
    return html`
        <ux-iws-link-wrapper class="ux-iws-teaser-press">
            <div class="ux-iws-teaser-press__content">
                <span class="ux-text-small">
                    ${date}
                </span>
                ${titleHtml}
            </div>
            <div class="ux-iws-teaser-press__cta">
                <a
                    href="${linkUrl}"
                    class="ux-button ux-button--icon-only"
                    title="next"
                    aria-label="next"
                    role="button"
                >
                    <ux-icon name="chevron-right" />
                </a>
            </div>
        </ux-iws-link-wrapper>
    `;
};

export const TeaserPressOneColumnTemplate = () => html`
    <div class="ux-row">
        <div class="ux-col-12 ux-u-mt-fluid-xs ux-u-mb-fluid-xxxs">
            <h2
                class="ux-text-headline ux-text-headline--big ux-u-text-align--center
                    ux-u-margin-bottom-5 ux-u-margin-xl-bottom-10 ux-u-margin-top-0"
            >
                Pressemitteilungen
            </h2>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1 ux-u-margin-bottom-35"
                >
                    ${dummyPressItems.map((pressElement, index) => {
                        return index > 3
                            ? html` ${TeaserPressTemplate(pressElement)} `
                            : html``;
                    })}
                    <div
                        class="ux-u-text-align--center ux-u-margin-top-30 u-clearfix"
                    >
                        <a class="ux-button">
                            Mehr anzeigen
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
`;

export const TeaserPressTwoColumnsTemplate = () => html`
    <div class="ux-u-mt-fluid-xs ux-u-mb-fluid-xxxs">
        <h2
            class="ux-text-headline ux-text-headline--big ux-u-text-align--center
                ux-u-margin-bottom-5 ux-u-margin-xl-bottom-10 ux-u-margin-top-0"
        >
            Pressemitteilungen
        </h2>
        <div class="ux-row ux-u-mx-zero">
            <div
                class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1 ux-col-md-5 ux-u-margin-bottom-35"
            >
                <div
                    class="ux-text-title-teaser ux-text-title--light ux-u-margin-top-15"
                >
                    Globale Pressemitteilungen
                </div>
                ${dummyPressItems.map((pressElement, index) => {
                    return index < 3
                        ? TeaserPressTemplate({
                              ...pressElement,
                              textLimit: true,
                          })
                        : "";
                })}
                <div
                    class="ux-u-text-align--center ux-u-margin-top-30 u-clearfix"
                >
                    <a class="ux-button">
                        Mehr anzeigen
                    </a>
                </div>
            </div>
            <div
                class="ux-col-12 ux-col-sm-10 ux-col-md-5 ux-u-offset-sm-1 ux-u-offset-md-0 ux-u-margin-bottom-3"
            >
                <div
                    class="ux-text-title-teaser ux-text-title--light ux-u-margin-top-15"
                >
                    Lokale Pressemitteilungen
                </div>
                ${dummyPressItems.map((item, index) => {
                    return index < 3
                        ? TeaserPressTemplate({
                              ...item,
                              textLimit: true,
                          })
                        : "";
                })}
                <div
                    class="ux-u-text-align--center ux-u-margin-top-30 u-clearfix"
                >
                    <a class="ux-button">
                        Mehr anzeigen
                    </a>
                </div>
            </div>
        </div>
    </div>
`;
